import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryTitleGray } from '../../../../app/theme/tokens/colors';
import { Spinner } from '../../../../shared/ui/Spinners';
import { WideLayout } from '../../../../shared/layout/widelayout';
import { usePortalStore } from '../../../../stores/portalStore';
import { useOrderFlowStore } from '../../store/newOrderFlowStore';
import { ResponsiveSelectPage } from '../../components/new-order/configure-equipment/ResponsiveSelectPage';

/**
 * Uso:
 * - Container da etapa "Configurar Equipamento" no fluxo de novo pedido.
 * - Faz a orquestração do estado global e delega UI para componentes especializados.
 *
 * Princípios:
 * - Componente fino: apenas guarda de navegação, obtenção de estado e composição.
 * - Lógica de formulário e apresentação ficam separadas em arquivos dedicados.
 * - Proteção de fluxo: sem subcategoria selecionada, redireciona com fallback seguro.
 */
export const ConfigureEquipment = () => {
    const [showTabOrder, setShowTabOrder] = useState(0);
    const currentUser = usePortalStore((state) => state.currentUser);
    const questions = useOrderFlowStore((state) => state.questions);
    const selectedSubCategory = useOrderFlowStore(
        (state) => state.selectedSubCategory
    );
    const navigate = useNavigate();

    useEffect(() => {
        if (!selectedSubCategory) {
            navigate('/order/selectSubCategory');
        }
    }, [selectedSubCategory, navigate]);

    if (!selectedSubCategory) {
        return (
            <WideLayout
                outlet={
                    <div
                        style={{
                            width: '100%',
                            minHeight: '60vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Spinner />
                    </div>
                }
            />
        );
    }

    return (
        <WideLayout
            outlet={
                <div style={{ padding: '10px' }}>
                    <h3 style={{ color: PrimaryTitleGray, margin: '10px 0' }}>
                        Gerando seu pedido
                    </h3>
                    <ResponsiveSelectPage
                        subCategory={selectedSubCategory}
                        questions={questions ?? []}
                        showTabOrder={showTabOrder}
                        setShowTabOrder={setShowTabOrder}
                        currentUser={currentUser}
                    ></ResponsiveSelectPage>
                </div>
            }
        ></WideLayout>
    );
};
